import { render } from "./CreateNewCustomer.vue?vue&type=template&id=9c4809d0&scoped=true"
import script from "./CreateNewCustomer.vue?vue&type=script&lang=js"
export * from "./CreateNewCustomer.vue?vue&type=script&lang=js"

import "./CreateNewCustomer.vue?vue&type=style&index=0&id=9c4809d0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c4809d0"]])

export default __exports__